const benefits = [
  { number: 1, title: "Cost Advantage", text: "Significantly lower prices compared to new OEM armored vehicles. Quality protection at a fraction of the cost." },
  { number: 2, title: "Proven Track Record", text: "Colombia has decades of experience in vehicle exports and specialized automotive services." },
  { number: 3, title: "Quality Maintenance", text: "Vehicles are typically well-maintained with lower mileage due to their specialized use and careful handling." },
  { number: 4, title: "Low Mileage", text: "Most vehicles feature exceptionally low mileage due to specialized use and careful handling by security professionals." },
  { number: 5, title: "Professional Inspection", text: "Every vehicle undergoes comprehensive technical inspection of armor, mechanical systems, and safety features." },
  { number: 6, title: "Global Demand", text: "High demand in Middle East, Africa, and Asia for reliable armored vehicles for VIP protection and security." },
  { number: 7, title: "Complete Service", text: "Full-service solution from sourcing to delivery, handling all logistics and documentation requirements." },
];

function WhyChooseUs() {
  return (
    <section className="section why-us" id="why-us">
      <div className="container">
        <h2 className="section-title">Why Choose Second Hand Colombian Armored Vehicles?</h2>
        <p className="section-subtitle">
          Full-service solution from sourcing to delivery, handling all logistics and documentation requirements.
        </p>

        <div className="benefits-grid">
          {benefits.map((benefit) => (
            <div key={benefit.number} className="benefit-item">
              <div className="benefit-number">{benefit.number}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
